import { useRef } from 'react';
import styled from 'styled-components';

import { Flex, Grid } from '@/components/base';
import Dropdown from '@/components/Dropdown/Dropdown';
import useColor from '@/hooks/domain/useColor';
import useModalState from '@/hooks/pure/useModalState';
import { modalStyle } from '@/styles/style';
import zIndex from '@/styles/zIndex';

type Props = {
  value: number;
  onChange: (v: number) => void;
};

const ColorSelector = (props: Props) => {
  const color = useColor();
  const ref = useRef<HTMLDivElement>(null);
  const { status, open, close } = useModalState();

  return (
    <>
      <Style
        onClick={(e) => {
          open();
        }}
        ref={ref}
      >
        {<ColorDot color={color.profile[props.value - 1 || 0]} />}
      </Style>
      <Dropdown status={status} triggerEl={ref.current} close={close}>
        <DropdownStyle columns="repeat(4, 1fr)" gap="4px">
          {color.profile.map((profileColor, index) => (
            <Style
              key={profileColor}
              onClick={() => {
                props.onChange(index + 1);
                close();
              }}
            >
              <ColorDot color={profileColor} />
            </Style>
          ))}
        </DropdownStyle>
      </Dropdown>
    </>
  );
};

const Style = styled(Flex).attrs({ a: 'center', j: 'center' })`
  width: 32px;
  height: 32px;
  border-radius: 4px;
  border: 1px solid ${(props) => props.theme.colors.gray400};
  cursor: pointer;
`;

const ColorDot = styled.div<{ color: string }>`
  background-color: ${(props) => props.color};
  width: 10px;
  height: 10px;
  border-radius: 6px;
`;

const DropdownStyle = styled(Grid)`
  z-index: ${zIndex.dropdown};
  flex-wrap: wrap;
  padding: 8px;
  ${modalStyle};
`;

export default ColorSelector;
